import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import useNavModel from '../model/navModel'
import useGlobalModel from '../model/globalModel'
import { forFind } from '../utils/utils'
import menuData from '../data/menuData.json'
import { Layout, Modal, Spin } from 'antd'
import AppMenu from './AppMenu'
import AppHeader from './AppHeader'
import AppNav from './AppNav'
import AppRoute from './AppRoute'
import logo from '@/assets/images/menuLogo.png'
import DocxPreview from './PDFPreview'

const { Sider, Content } = Layout

const Index = () => {
    const history = useHistory()
    const {
        user,
        cm,
        loadingInfo: { loadingVisible, txt },
        setLoadingInfo,
        officeLookInfo,
        setOfficeLookInfo,
    } = useGlobalModel()
    const { addNav } = useNavModel()

    //监听在地址栏输入url。
    useEffect(() => {
        history.listen((location, action) => {
            //每次切换页面 关闭全局loading
            setLoadingInfo({ loadingVisible: false, txt: '' })

            if (action === 'POP' && location.pathname !== '/login' && user.token) {
                let findNav = forFind(menuData, location.pathname, 'path', true)
                // console.log(location, action, "监听路有变化", findNav)
                addNav(findNav ? findNav.id : '404')
            }
        })
    }, [])

    return (
        <Layout style={{ height: '100vh' }}>
            <Layout>
                <Sider className="layout-sider menu-box" trigger={null} collapsible collapsed={cm.collapsed} width={208}>
                    {/* <div className="layout-sider-shop">{user.shopName}1</div> */}
                    <div className="layout-sider-top">
                        <img src={logo} />
                        <span>加盟商管理系统</span>
                    </div>
                    <AppMenu />
                </Sider>
                <Layout className="layout-section">
                    <AppHeader />
                    <AppNav />
                    <Spin tip={txt} spinning={loadingVisible} style={{ zIndex: 999 }}>
                        <Content>
                            <div className="layout-section-content">
                                <AppRoute />
                            </div>
                        </Content>
                    </Spin>
                </Layout>
            </Layout>
            {/* 文件预览 */}
            <DocxPreview />
        </Layout>
    )
}

export default Index
